export const OUTPUT_ARTICLES_LENGTH = 4;
export const TOP_ARTICLES_TYPES = ['photogallery', 'rating'];
export const TRAFFIC_ARTICLE_ALIAS = ''; // `brandvoice/481012-ot-prestuplenia-do-nakazania-bor-be-s-prestupnost-u-pomozet-iskusstvennyj-intellekt`
